
<div class="woods-img-wally">
    <img class="woods-img-wally" src="../../../assets/img/wally/wally.png" alt="wally">
</div>
